module.exports = __webpack_public_path__ + "OpenSans-ExtraBoldItalic.bc511bacf828ac9e833e.woff2";


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/node_modules/npm-font-open-sans/fonts/ExtraBoldItalic/OpenSans-ExtraBoldItalic.woff2
// module id = ../../../../npm-font-open-sans/fonts/ExtraBoldItalic/OpenSans-ExtraBoldItalic.woff2
// module chunks = styles